/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { AppContext } from '@/app'
import { accountClient } from '@/services/cloudClient/accountClient'
import { useCallback, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function useLogout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { setMetaData } = useContext(AppContext)

  const logout = useCallback((to?: string) => {
    return accountClient.accountsSelfApi
      .logout()
      .then(() => {
        setMetaData(null)
        // 清除notification标记，确保下次登录时能正常显示
        sessionStorage.removeItem('contract-notifications-shown')
      })
      .finally(() => {
        navigate(to ?? location)
      })
  }, [])

  return logout
}
